var map = {
	"./boar.png": "534c",
	"./bound.png": "532f",
	"./bracken.png": "996c",
	"./composite.png": "2807",
	"./dapitan.png": "3b08",
	"./dapitana.png": "1783",
	"./death.png": "9a08",
	"./guerrico.png": "dda9",
	"./jesus.png": "e907",
	"./mercado.png": "3b33",
	"./revenge.png": "793a"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) { // check for number or string
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return id;
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "7ab9";